import { create } from "zustand";
import { SubscriptionType } from "../../../Common/constants/subscriptionConst";

export type WLResponseIcon = "lock" | "none" | SubscriptionType;

interface WLResponseDialogProps {
  icon: WLResponseIcon;
  title: string;
  description: string;
  onConfirm: () => void;
  onConfirmText: string;
}

interface WLResponseDialogState {
  isOpen: boolean;
  icon: WLResponseIcon;
  title: string;
  description: string;
  onConfirmText: string;
  onConfirm: () => void;
  showDialog: (props: WLResponseDialogProps) => void;
  hideDialog: () => void;
  reset: () => void;
}

export const useWLResponseDialogStore = create<WLResponseDialogState>(
  (set) => ({
    isOpen: false,
    icon: "none",
    title: "",
    description: "",
    onConfirmText: "Okay",
    onConfirm: () =>
      set({
        isOpen: false,
      }),
    showDialog: (props) =>
      set({
        ...props,
        onConfirm: () => {
          props.onConfirm();
          set({ isOpen: false });
        },
        isOpen: true,
      }),
    hideDialog: () =>
      set({
        isOpen: false,
      }),
    reset: () =>
      set({
        isOpen: false,
        icon: "none",
      }),
  })
);
